import { VerificationFlow } from "@ory/client-fetch";
import { Verification as OryVerification } from "@ory/elements-react/theme";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createSdkErrorHandler, oryConfig, sdk } from "./ory-sdk";

export const Verification = () => {
  const [flow, setFlow] = useState<VerificationFlow | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const returnTo = searchParams.get("return_to");
  const flowId = searchParams.get("flow");

  const navigate = useNavigate();

  const getFlow = useCallback(
    async (flowId: string) => {
      const flowData = await sdk.getVerificationFlow({ id: flowId });
      setFlow(flowData);
    },
    [setFlow]
  );

  const sdkErrorHandler = createSdkErrorHandler(
    navigate,
    getFlow,
    setFlow,
    "/verification",
    true
  );

  const createFlow = async () => {
    try {
      const flowData = await sdk.createBrowserVerificationFlow({
        ...(returnTo && { returnTo: returnTo }),
      });
      setSearchParams({ flow: flowData.id });
      setFlow(flowData);
    } catch (error) {
      await sdkErrorHandler(error);
    }
  };

  useEffect(() => {
    if (flowId) {
      getFlow(flowId).catch(() => createFlow());
      return;
    }
    createFlow();
  }, []);

  if (!flow) {
    return (
      <div className="h-[576px] px-12 pt-12">Loading authorization...</div>
    );
  }

  return (
    <div className="py-0">
      <OryVerification
        flow={flow}
        config={oryConfig}
        components={{
          Card: {
            Footer: () => (
              <div className="flex flex-col gap-2 text-sm mt-4">
                <button
                  type="button"
                  onClick={() => {
                    navigate({ pathname: "/signup" }, { replace: true });
                  }}
                  className="text-primary hover:underline"
                >
                  Back to sign up
                </button>
              </div>
            ),
          },
        }}
      />
    </div>
  );
};
